import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
export var CITY_STATION_NAME = "cityOffice";
export var RAIL_STATION_NAME = "rail";
export var AIRPORT_STATION_NAME = "airport";
export var AIRPORT_TERMINAL_STATION_NAME = "airportTerminal";
export var AIRPORT_SHUTTLE_STATION_NAME = "airportShuttle";
export var HOTEL_STATION_NAME = "hotel";
export var DELIVERY_STATION_NAME = "delivery";
export var STATION_KINDS = [
    CITY_STATION_NAME,
    RAIL_STATION_NAME,
    AIRPORT_STATION_NAME,
    AIRPORT_TERMINAL_STATION_NAME,
    AIRPORT_SHUTTLE_STATION_NAME,
    HOTEL_STATION_NAME, 
];
var stationKinds = _to_consumable_array(STATION_KINDS);
